export enum PaymentActions {
  ReadAdminInvoiceDetails = 'payment:ReadAdminInvoiceDetails',
}
